import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { apiRequest } from "../../Lib/Utils/ApiRequest";
import { invalidateBookingInflight } from "./getBooking";
import { IApiResponse, IExchangeOfferResponse, IPreExchangeOperationRequest, IPreExchangeOperationResponse, IQuickExchangeOfferRequest } from "../../Orchestrator/Types/Index";
import { IExternalPaymentRequest, IExternalPaymentResponse, IZeroPaymentResponse } from "../../Orchestrator/Types/Interface/IPayment";
import { ExternalPaymentResponse } from "../../Orchestrator/Types/Types/BookingTypes";

export async function postExchangeOffer(
    exchangeOfferRequest: IQuickExchangeOfferRequest,
    bookingId: string,
    showErrorToast: boolean = true,
    showLoader: boolean = true
): Promise<IApiResponse<IExchangeOfferResponse>> {

    const ENDPOINTS = await getEndpoints();
    const endpoint = `${ENDPOINTS.bookingsExchangeOffers(bookingId)}`;

    return await apiRequest<IExchangeOfferResponse>(
        endpoint,
        'POST',
        { body: JSON.stringify(exchangeOfferRequest) },
        "none",
        undefined,
        undefined,
        showLoader,
        showErrorToast
    );
}

export async function postPreExchangeOperation(
    preExchangeRequest: IPreExchangeOperationRequest,
    bookingId: string
): Promise<IApiResponse<IPreExchangeOperationResponse>> {
    const ENDPOINTS = await getEndpoints();
    const endpoint = `${ENDPOINTS.preExchangeOperationStart(bookingId)}`;
    // `return await`, not `return`: without the await the finally runs at
    // ISSUE time, before the mutation commits, which silently reopens the bug
    // this fixes. Pinned by C13's sibling C11 in getBookingCoalesce.test.ts.
    try {
        return await apiRequest<IPreExchangeOperationResponse>(endpoint, 'POST', {
            body: JSON.stringify(preExchangeRequest),
        });
    } finally {
        // The booking now holds the exchanged-out + PREBOOKED replacement offers.
        // Callers read it back immediately (upgrade-to-premium, change-date,
        // quick-exchange) and must not be served a read that left before this.
        // In `finally` so a future apiRequest that throws (today it returns a
        // {status:"ko"} envelope instead) cannot skip the eviction. Evicting
        // after a FAILED mutation is harmless — worst case one extra GET.
        invalidateBookingInflight(bookingId);
    }
}


export async function postExternalPayment(
    externalPaymentRequest: IExternalPaymentRequest,
    bookingId: string
): Promise<IApiResponse<IExternalPaymentResponse>> {
    const ENDPOINTS = await getEndpoints();
    const endpoint = `${ENDPOINTS.externalPaymentAPI(bookingId)}`;
    return await apiRequest<ExternalPaymentResponse>(endpoint, 'POST', {
        body: JSON.stringify(externalPaymentRequest),
    });
}

export async function postZeroPayment(
    zeroPaymentRequest: any,
    bookingId: string
): Promise<IApiResponse<IZeroPaymentResponse>> {
    const ENDPOINTS = await getEndpoints();
    const endpoint = `${ENDPOINTS.zeroPaymentAPI(bookingId)}`;
    return await apiRequest<IZeroPaymentResponse>(endpoint, 'POST', {
        body: JSON.stringify(zeroPaymentRequest),
    });
}

export async function cancelExchangeOffers(
    bookingId: string,
    exchangeOperationId: string
): Promise<IApiResponse<IExchangeOfferResponse>> {
    const ENDPOINTS = await getEndpoints();
    const endpoint = `${ENDPOINTS.cancelExchangeOffers(bookingId, exchangeOperationId)}`;
    // `return await` is load-bearing here too — see postPreExchangeOperation.
    try {
        return await apiRequest<IExchangeOfferResponse>(endpoint, 'DELETE',
            // {body: JSON.stringify(zeroPaymentRequest)}
        );
    } finally {
        // Rolls the booking back to its pre-exchange offers — same read-after-write
        // hazard as postPreExchangeOperation, in the other direction.
        invalidateBookingInflight(bookingId);
    }
}
